// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__FUgIo","dragIcon":"Choice_dragIcon__2J4IM","left":"Choice_left__1juoy","input":"Choice_input__mu1__"};